import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import {
    buildPageContextFields,
    buildPromptFields,
    buildLyraAdviceFields,
    buildSentimentChipFields,
    buildShadeFinderProductFields,
    buildShadeFinderShadeFields
} from 'ai/analytics/utils/sotFields';
import { EVENT_NAMES } from 'ai/analytics/events';

export function trackPromptClick({ promptText, pageContext = {} }) {
    if (!promptText) {
        return;
    }

    const eventName = EVENT_NAMES.PROMPT_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildPromptFields(promptText),
        ...buildLyraAdviceFields()
    };

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        },
        finishEventWithoutTimeout: true
    });
}

export function trackFollowUpClick({ followUpText, pageContext = {}, messageId, previousMessageId }) {
    if (!followUpText) {
        return;
    }

    const eventName = EVENT_NAMES.FOLLOW_UP_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildPromptFields(followUpText, messageId, previousMessageId),
        ...buildLyraAdviceFields()
    };

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        }
    });
}

export function trackSentimentChipClick({ value, position, type, pageContext = {} }) {
    if (!value || !position) {
        return;
    }

    const eventName = EVENT_NAMES.SENTIMENT_CHIP_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildSentimentChipFields({ value, position, type }),
        ...buildLyraAdviceFields()
    };

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        }
    });

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
            actionInfo: `${anaConsts.SUPER_CHAT.SUPERCHAT_REVIEW_SENTIMENTS}:${value}`
        }
    });
}

export function trackShadeFinderProductSelected({
    sessionId, messageId, productId, productName, brandName
}) {
    const eventName = EVENT_NAMES.SHADE_FINDER_PRODUCT_SELECTED;
    const sotFields = buildShadeFinderProductFields({
        sessionId,
        messageId,
        productId,
        productName,
        brandName
    });

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        }
    });
}

export function trackShadeFinderShadeSelected({
    sessionId, messageId, skuId, shadeCode, productId
}) {
    const eventName = EVENT_NAMES.SHADE_FINDER_SHADE_SELECTED;
    const sotFields = buildShadeFinderShadeFields({
        sessionId,
        messageId,
        skuId,
        shadeCode,
        productId
    });

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        }
    });
}

export function trackSignInCTAClick({ pageContext = {} }) {
    const eventName = EVENT_NAMES.SIGN_IN_CTA_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildLyraAdviceFields()
    };

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        }
    });
}
